/**
 * Single source of truth for password rules (S-33).
 * Registration, change-password, and reset-password all consume this module
 * so the strength requirement cannot drift between flows.
 */

export const PASSWORD_MIN_LENGTH = 8;

const RULES = [
  {
    test: (v) => v && v.length >= PASSWORD_MIN_LENGTH,
    message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long.`,
  },
  { test: (v) => /[A-Z]/.test(v), message: "Password must contain at least one uppercase letter." },
  { test: (v) => /[a-z]/.test(v), message: "Password must contain at least one lowercase letter." },
  { test: (v) => /[0-9]/.test(v), message: "Password must contain at least one number." },
  {
    test: (v) => /[!@#$%^&*(),.?":{}|<>]/.test(v),
    message: "Password must contain at least one special character.",
  },
];

export function validatePassword(value) {
  if (!value || value.trim().length === 0) {
    return { valid: false, error: "This field is required" };
  }
  for (const rule of RULES) {
    if (!rule.test(value)) return { valid: false, error: rule.message };
  }
  return { valid: true, error: null };
}

// Ant Design Form rule adapter
export const antPasswordValidator = (_, value) => {
  const { valid, error } = validatePassword(value);
  return valid ? Promise.resolve() : Promise.reject(new Error(error));
};
